// testMap.jsx
import { extend } from '@react-three/fiber'
import * as THREE from 'three/webgpu'
import { GridMaterial } from './materials/GridMaterial'
import { useGLTF } from '@react-three/drei'

extend(THREE)

export default function TestMap({ size }) {
    const { nodes } = useGLTF('/models/terrain.glb')    
    
    return (
        <mesh
            geometry={nodes.floor.geometry}
            receiveShadow
        >
            <GridMaterial />
        </mesh>
    )
}
